<template>
  <el-dialog
    title="订单信息"
    :visible.sync="detailShow"
    width="780px"
    :before-close="handleClose">
    <div class="center">
      <div class="flex">
        <div class="box">
          <div class="text" style="display: flex;">影片图片：
            <el-image
              class="img"
              :src="detailInfo.cinema.moviePic"
              :preview-src-list="Array(detailInfo.cinema.moviePic)">
            </el-image>
          </div>
          <div class="text">影片名称：<span>{{detailInfo.cinema.movieName}}</span></div>
          <div class="text">放映时间：<span>{{detailInfo.cinema.showTimeStr}}</span></div>
          <div class="text">影院：<span>{{detailInfo.cinema.cinemaName}}</span></div>
          <div class="text">取票码：<span v-for="(item,index) in detailInfo.ticketCodeList">{{item.code}}{{detailInfo.ticketCodeList.length>1?',':''}}</span></div>
          <div class="text" v-if="[4,5].includes(detailInfo.orderStatus) &&  detailInfo.ticketInfo.seat != null && detailInfo.ticketInfo.seat!=''">实际座位：<span>{{detailInfo.ticketInfo.seat}}</span></div>
        </div>
        <div class="box" style="margin-left: 54px">
          <div class="text">购票座位：<span>{{detailInfo.cinema.seat}}</span></div>
          <div class="text">下单时间：<span>{{detailInfo.cinema.createTime}}</span></div>
          <div class="text">厅/语言：<span>{{detailInfo.cinema.hallName}}{{detailInfo.cinema.showVersion}}</span></div>
          <div class="text">城市：<span>{{detailInfo.cinema.city}}</span></div>
          <div class="text">地址：<span>{{detailInfo.cinema.cinemaAddress}}</span></div>
          <div class="text" style="display: flex">取票码截图：
            <div  v-for="(item,index) in detailInfo.ticketImgList">
              <el-image
                class="img"
                :src="item.url"
                :preview-src-list="Array(item.url)">
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['detailShow', 'detailInfo'],
  name: "detail",
  data(){
    return{

    }
  },
  methods:{
    handleClose(){
      this.$parent.detailShow = false
    }
  }
}
</script>

<style scoped lang="less">
.center{
  .flex{
    display: flex;
    align-items: center;
    .box{
      .text{
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 20px;
        margin-bottom: 10px;
        span{
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          line-height: 20px;
          margin-left: 10px;
        }
        .img{
          width: 60px;
          height: 106px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/components/detail.vue